import {Theme, ThemeContrast, ThemeSettings} from '~shared/models/settings';

const highContrastThemes = [Theme.LightHighContrast, Theme.DarkHighContrast];

/*
    Пользовательские настройки для задания темы должны быть в виде:
    {
        theme?: 'system' | 'light' | 'light-hc' | 'dark' | 'dark-hc',
        themeSettings?: {
            systemLightTheme?: 'light' | 'light-hc' | 'dark' | 'dark-hc',
            systemDarkTheme?: 'light' | 'light-hc' | 'dark' | 'dark-hc',
        }
    }
    Настройки контрастности для системной темы задаются через свойства systemLightTheme/systemDarkTheme
    и поэтому определять контрастная ли тема стоит через эти поля в themeSettings.
    Подробности в https://st.yandex-team.ru/DATAUI-1256.
*/
export const getThemeSettings = (themeType: string, themeContrast: ThemeContrast) => {
    const isHighContrastTheme = themeContrast === ThemeContrast.High;
    let theme: Theme = themeType as Theme;

    if (isHighContrastTheme) {
        theme = addThemeContrast(theme);
    }

    return {
        theme: theme,
        themeSettings: {
            systemLightTheme: isHighContrastTheme ? Theme.LightHighContrast : Theme.Light,
            systemDarkTheme: isHighContrastTheme ? Theme.DarkHighContrast : Theme.Dark,
        } as ThemeSettings,
    };
};

export const getThemeType = (theme: Theme) => {
    if (highContrastThemes.includes(theme)) {
        return removeThemeContrast(theme);
    }

    return theme;
};

export const isHighContrastTheme = (themeSettings: ThemeSettings) => {
    return themeSettings?.systemLightTheme === Theme.LightHighContrast;
};

export const addThemeContrast = (theme: Theme) => {
    let themeWithContrast = theme;

    switch (theme) {
        case Theme.Light:
            themeWithContrast = Theme.LightHighContrast;
            break;
        case Theme.Dark:
            themeWithContrast = Theme.DarkHighContrast;
            break;
    }

    return themeWithContrast;
};

export const removeThemeContrast = (theme: Theme) => {
    let themeWithoutContrast = theme;

    switch (theme) {
        case Theme.LightHighContrast:
            themeWithoutContrast = Theme.Light;
            break;
        case Theme.DarkHighContrast:
            themeWithoutContrast = Theme.Dark;
            break;
    }

    return themeWithoutContrast;
};
